// extracted by mini-css-extract-plugin
module.exports = {"warningModal":"warning-mes-form_warningModal_m0RQP","textarea":"warning-mes-form_textarea_8ExGx","point":"warning-mes-form_point_mlVH5"};